import { Component, Input } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { IParkerProfileDetail } from 'src/app/shared/interfaces';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { AmanoOneParkerSettingsComponent } from '../../../parker-parcs/amano-one-parker-settings/amano-one-parker-settings.component';

@Component({
  selector: 'app-parcs-management-home',
  standalone: true,
  imports: [
    MatTabsModule,
    MatListModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCardModule,
    AmanoOneParkerSettingsComponent,
  ],
  templateUrl: './parcs-management-home.component.html',
  styleUrl: './parcs-management-home.component.scss',
})
export class ParcsManagementHomeComponent {
  _parkerDetail: IParkerProfileDetail;

  @Input() set parkerDetail(value: IParkerProfileDetail) {
    this._parkerDetail = value;
  }
  currentPARCSelected: string = 'AMANO ONE';
  currentPARCTitle: string = 'Amano One Settings';
}
